import React, {useContext} from 'react';
import {Grid, Typography} from '@material-ui/core';
import {makeStyles, useTheme} from '@material-ui/core/styles';
import WidgetCard from '../WidgetCard';
import MMCdates from './MMCtools/MMCdates';
import MMCdomestic from './MMCtools/MMCdomestic';
import MMCinternational from './MMCtools/MMCinternational';
import {PBold} from 'components/TypographyShortcuts';
import {UserContext} from 'context';
import MMCcontinuity from 'components/mmld/MMCtools/MMCcontinuity';

const useStyles = makeStyles(theme => ({
    fieldLabel: {
        fontWeight: 'bold',
        marginBottom: '0em',
    },
    summary: {
        padding: '0rem',
    },
}));

const ViewMMCCore = () => {
    const classes = useStyles();
    const theme = useTheme();
    const {mmlds} = useContext(UserContext);
    const continuityNotice = mmlds?.mmld_docs?.CONTINUITY?.length > 0;

    return (
        <>
            <Grid container className={classes.root} direction='column'>
                <MMCdates mmld={mmlds} />
                <p></p>
                <Grid item>
                    <MMCdomestic mmld={mmlds} doc_type='MMC' />
                </Grid>
                <p></p>
                <Grid item>
                    <MMCinternational mmld={mmlds} doc_type='MMC' />
                </Grid>
            </Grid>
            {/* continuity info */}
            <Grid container className={classes.root} direction='column'>
                {continuityNotice === true && (
                    <Grid>
                        <Grid
                            item
                            style={{
                                border: 'solid 1px',
                                borderRadius: '0.5em',
                                padding: '1em',
                                margin: '1em',
                                backgroundColor: theme.palette.gray.light2,
                            }}
                        >
                            <Typography
                                variant='body1'
                                align='center'
                                className={classes.fieldLabel}
                            >
                                <PBold>
                                    The following credentials are in Continuity
                                </PBold>
                            </Typography>
                        </Grid>
                        <Grid item>
                            <MMCcontinuity mmld={mmlds} doc_type='CONTINUITY' />
                        </Grid>
                    </Grid>
                )}
            </Grid>
        </>
    );
};

const ViewMMC = () => {
    return (
        <WidgetCard>
            <ViewMMCCore />
        </WidgetCard>
    );
};

export default ViewMMC;
export {ViewMMCCore, ViewMMC};
